<template>
  <div class="blocked_logs_page">
    <h1>用户arpu报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="language" placeholder>
        <el-option
          v-for="(item, itemIndex) in languageList"
          v-bind:key="itemIndex + 199"
          :label="item.language"
          :value="item.langCode"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="country" placeholder>
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="userType" placeholder>
        <el-option
          v-for="(item, itemIndex) in userTypes"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="isPay" placeholder>
        <el-option
          v-for="(item, itemIndex) in isPays"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        style="width: 160px"
        v-model="duration"
        placeholder="请输入时间"
      ></el-input>
      <el-date-picker
        v-model="platformData"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="retainedOptions"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1"
        >查询</el-button
      >
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-row>
      <el-table :data="tableList" border v-loading="login1">
        <el-table-column align="center"  prop="date" label="日期" sortable>
        </el-table-column>
        <el-table-column align="center"  prop="dau" label="dau" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num != ''"   prop="credit" :label="num + '日充值金额'" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num != ''"  prop="rechargeNumber" :label="num + '日充值人数'" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num != ''"  prop="arppu" :label="num + '日arppu'" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num != ''"  prop="arpu" :label="num + '日arpu'" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="credit1" label="1日充值金额" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="rechargeNumber1" label="1日充值人数" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arppu1" label="1日arppu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arpu1" label="1日arpu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="credit3" label="3日充值金额" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="rechargeNumber3" label="3日充值人数" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arppu3" label="3日arppu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arpu3" label="3日arpu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="credit7" label="7日充值金额" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="rechargeNumber7" label="7日充值人数" sortable>
        </el-table-column>
        v<el-table-column align="center" v-if="num == ''"  prop="arppu7" label="7日arppu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arpu7" label="7日arpu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="credit14" label="14日充值金额" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="rechargeNumber14" label="14日充值人数" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arppu14" label="14日arppu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arpu14" label="14日arpu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="credit30" label="30日充值金额" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="rechargeNumber30" label="30日充值人数" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arppu30" label="30日arppu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arpu30" label="30日arpu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="credit90" label="90日充值金额" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="rechargeNumber90" label="90日充值人数" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arppu90" label="90日arppu" sortable>
        </el-table-column>
        <el-table-column align="center" v-if="num == ''"  prop="arpu90" label="90日arpu" sortable>
        </el-table-column>
        
      </el-table>
    </el-row>
    <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="10"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data () {
    return {
      login1: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: -1,
      userTypes: [
        {
          label: 'total',
          value: -1
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 0
        }
      ],
      isPay: -1,
      isPays: [
        {
          label: 'total',
          value: -1
        },
        {
          label: '非付费用户',
          value: 0
        },
        {
          label: '付费用户',
          value: 1
        }
      ],
      page: 1,
      total: 0,
      duration: '',
      num:'',
    }
  },
  beforeCreate () {},
  created () {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted () {},
  computed: {
    username () {
      return this.$store.getters.username
    },
    userLevel () {
      return this.$store.getters.userLevel
    },
    token () {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages () {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_ () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list () {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.ar_pu + '?username=' + this.$store.getters.username + '&token=' + this.$store.getters.token,
        withCredentials: true,
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          countryCode: this.country,
          langId: this.language,
          isNew: this.userType,
          isPay: this.isPay,
          duration: this.duration,
          page: this.page
        }
      })
      if (res !== null) {
        this.num = ''
        if (this.duration != '') {
          this.num = this.duration
        }
        
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
    // 分页
    handleCurrentChange (num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true
      const res = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.ar_pu_download+ '?username=' + this.$store.getters.username + '&token=' + this.$store.getters.token,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          countryCode: this.country,
          langId: this.language,
          isNew: this.userType,
          isPay: this.isPay,
          duration: this.duration,
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '用户arpu报表' + '')
    }
  }
}
</script>

<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
